import React, { useContext, useState } from 'react';
import MainContext from '../../contexts/MainContext';
import { BetslipContext } from '../../data/betslip/BetslipConf';
import { getConfiguration, getLocaleDotRound, getPrintableAmount, getValidAmountString, getAmountInCent, getCurrencyValue} from '../../data/utils';
import { getLabel } from '../../InitData';

function FastbetAmount(props) {
    const betslipContext = useContext(BetslipContext);
    const mainContext = React.useContext(MainContext);
    let conf = getConfiguration();
    let mult = conf.cs.m;
    let nDec = conf.cs.nd;
    let charDecimalBrowser = getLocaleDotRound().round;
    const amountUnit = conf.cs.imu;
    const minimumAmount = betslipContext.minimumBetAmount;
    const minimum = getCurrencyValue(minimumAmount,conf.cs.m, conf.cs.nd, conf.cs.ct);
    const unit = getCurrencyValue(amountUnit,conf.cs.m, conf.cs.nd, conf.cs.ct);
    const errorMessage = `${getLabel('carrello.error.minimum_amount_part1')} ${minimum} ${getLabel('carrello.error.minimum_amount_part2')} ${unit}`;
    const [showCalc, toggleCalc] = useState(false);
    const [printableAmount, setPrintableAmount] = useState(getPrintableAmount(minimumAmount, conf.cs.m, conf.cs.nd));
    const [showError, setShowError] = useState(false);
    
    function setAmountFromCalc(amountCalc) {
        amountCalc = getPrintableAmount(amountCalc, mult, nDec);
        const charThousandBrowser = getLocaleDotRound().dot;
        amountCalc = amountCalc.replaceAll(charThousandBrowser, ''); // remove the thousand char from the string. In the setAmount only "decimal" is permitted
        setAmount(amountCalc);
    }

   function setAmount(newAmount){
	   // get a valid input field value for this amount: only number and dot, and max nDec digit after it
	   newAmount = getValidAmountString(newAmount);
	   // putting the "browser decimal dot" instead of the "." for the float type
	   let fieldTextValue = newAmount;
	   fieldTextValue = fieldTextValue.replace(".", charDecimalBrowser);

       let showErrorMessage = false;
	   if(isNaN(newAmount) === false && newAmount.length > 0){
            const amountInCent = getAmountInCent(parseFloat(newAmount), mult);
            const isMultiple = amountInCent % amountUnit === 0;
	        if (amountInCent < minimumAmount || isMultiple === false ) {
                showErrorMessage = true;
            }
	   }

       setPrintableAmount(fieldTextValue);
       setShowError(showErrorMessage);
	}
   
    function addChar(symb){
    	symb = symb + '';
    	let amountString = printableAmount + '';
    	if (printableAmount === '0') {
    		amountString = '';
    	}
    	amountString = amountString + symb;
    	setAmount(amountString);
    }

    function enableFastbet() {
        const amountInCent = getAmountInCent(parseFloat(printableAmount), mult);
        mainContext.toggleFastbetPopup();
        betslipContext.enableAddAndBet(amountInCent);
    }

    const fastbetEnabled = betslipContext.isAddAndBetEnabled();
    
    return (
        <>
            <div  className="inserimento-puntata">
                <div className={"d-flex align-items-center justify-content-between"} >
                        <p className={"label-for-amount-input ellipsis"}>{getLabel('live.fastbet.bet_amount')}</p>
                        <input type="text" onChange={e => setAmount(e.target.value + "")}
                                className="input-calc calcolatrice-input"
                                value={printableAmount} placeholder={getLabel('carrello.puntata')} />
                </div>
                <div className="bottoni-calc">
                    {conf.bak.vls.map(a =>
                        <input key={a} type="button" onClick={() => setAmountFromCalc(a)} value={getPrintableAmount(a, mult, nDec)}  />
                    )}
                    <a onClick={() =>  toggleCalc(!showCalc)} className="apri-calc bg-nero bianco bordo-tondo pointer">
                        <i className="fas fa-calculator"></i>
                    </a>
                </div>
                {showCalc &&
                    <div className="calcSingola-keys margine-su-mezzo">
                        <div className="riga-calc">
                            {[1,2,3,4,5].map((value, i) => {
                                return (
                                    <button key={i} onClick={e => addChar(e.target.value)} type="button" value={value}>{value}</button>
                                );
                            })}
                            <button onClick={() => setAmount('0')} type="button" className="all-clear bg-rosso bianco" value="all-clear">C</button>
                        </div>
                        <div className="riga-calc">
                            {[6,7,8,9,0].map((value, i) => {
                                return (
                                    <button key={i} onClick={e => addChar(e.target.value)} type="button" value={value}>{value}</button>
                                );
                            })}
                            {nDec > 0 &&
                                <button onClick={e => addChar(e.target.value)} type="button" className="decimal" value={charDecimalBrowser}>{charDecimalBrowser}</button>
                            }
                        </div>
                    </div>
                }
            </div>
            {showError ?
                <span className="testo-piccolo">{errorMessage}</span>
                :
                <button className="customPopup__content__body__clickable customPopup__content__body__clickable--success text-uppercase mt-2" onClick={enableFastbet}>{fastbetEnabled ? getLabel('live.fastbet_popup.confirm') : getLabel('live.fastbet_popup.enable')}</button>
            }
        </>
    );
}

export default FastbetAmount;